import React from 'react'

export const DE = () => (
  <svg
    width='21px'
    height='15px'
    viewBox='0 0 21 15'
    version='1.1'
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>DE</title>
    <defs>
      <linearGradient
        x1='50%'
        y1='0%'
        x2='50%'
        y2='100%'
        id='linearGradient-1-de'
      >
        <stop stopColor='#FFFFFF' offset='0%'></stop>
        <stop stopColor='#F0F0F0' offset='100%'></stop>
      </linearGradient>
      <linearGradient
        x1='50%'
        y1='0%'
        x2='50%'
        y2='100%'
        id='linearGradient-2-de'
      >
        <stop stopColor='#262626' offset='0%'></stop>
        <stop stopColor='#0D0D0D' offset='100%'></stop>
      </linearGradient>
      <linearGradient
        x1='50%'
        y1='0%'
        x2='50%'
        y2='100%'
        id='linearGradient-3-de'
      >
        <stop stopColor='#F01515' offset='0%'></stop>
        <stop stopColor='#DE0000' offset='100%'></stop>
      </linearGradient>
      <linearGradient
        x1='50%'
        y1='0%'
        x2='50%'
        y2='100%'
        id='linearGradient-4-de'
      >
        <stop stopColor='#FFD521' offset='0%'></stop>
        <stop stopColor='#FFCF00' offset='100%'></stop>
      </linearGradient>
    </defs>
    <g
      id='Symbols'
      stroke='none'
      strokeWidth='1'
      fill='none'
      fillRule='evenodd'
    >
      <g id='DE'>
        <rect
          id='FlagBackground'
          fill='url(#linearGradient-1-de)'
          x='0'
          y='0'
          width='21'
          height='15'
        ></rect>
        <rect
          id='Rectangle-2'
          fill='url(#linearGradient-2-de)'
          x='0'
          y='0'
          width='21'
          height='5'
        ></rect>
        <rect
          id='Rectangle-2'
          fill='url(#linearGradient-3-de)'
          x='0'
          y='5'
          width='21'
          height='5'
        ></rect>
        <rect
          id='Rectangle-2'
          fill='url(#linearGradient-4-de)'
          x='0'
          y='10'
          width='21'
          height='5'
        ></rect>
      </g>
    </g>
  </svg>
)

export const IT = () => (
  <svg
    width='21px'
    height='15px'
    viewBox='0 0 21 15'
    version='1.1'
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>IT</title>
    <defs>
      <linearGradient
        x1='50%'
        y1='0%'
        x2='50%'
        y2='100%'
        id='linearGradient-1-it'
      >
        <stop stopColor='#FFFFFF' offset='0%'></stop>
        <stop stopColor='#F0F0F0' offset='100%'></stop>
      </linearGradient>
      <linearGradient
        x1='50%'
        y1='0%'
        x2='50%'
        y2='100%'
        id='linearGradient-2-it'
      >
        <stop stopColor='#E43D4C' offset='0%'></stop>
        <stop stopColor='#CC2E3C' offset='100%'></stop>
      </linearGradient>
      <linearGradient
        x1='50%'
        y1='0%'
        x2='50%'
        y2='100%'
        id='linearGradient-3-it'
      >
        <stop stopColor='#1BB65D' offset='0%'></stop>
        <stop stopColor='#139149' offset='100%'></stop>
      </linearGradient>
    </defs>
    <g
      id='Symbols'
      stroke='none'
      strokeWidth='1'
      fill='none'
      fillRule='evenodd'
    >
      <g id='IT'>
        <rect
          id='FlagBackground'
          fill='url(#linearGradient-1-it)'
          x='0'
          y='0'
          width='21'
          height='15'
        ></rect>
        <rect
          id='Mask'
          fill='url(#linearGradient-2-it)'
          x='10'
          y='0'
          width='11'
          height='15'
        ></rect>
        <rect
          id='Rectangle-2'
          fill='url(#linearGradient-3-it)'
          x='0'
          y='0'
          width='7'
          height='15'
        ></rect>
        <rect
          id='Rectangle-2-Copy'
          fill='url(#linearGradient-1-it)'
          x='7'
          y='0'
          width='7'
          height='15'
        ></rect>
      </g>
    </g>
  </svg>
)

export const FR = () => (
  <svg
    width='21px'
    height='15px'
    viewBox='0 0 21 15'
    version='1.1'
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>FR</title>
    <defs>
      <linearGradient
        x1='50%'
        y1='0%'
        x2='50%'
        y2='100%'
        id='linearGradient-1-fr'
      >
        <stop stopColor='#FFFFFF' offset='0%'></stop>
        <stop stopColor='#F0F0F0' offset='100%'></stop>
      </linearGradient>
      <linearGradient
        x1='50%'
        y1='0%'
        x2='50%'
        y2='100%'
        id='linearGradient-2-fr'
      >
        <stop stopColor='#F44653' offset='0%'></stop>
        <stop stopColor='#EE2A39' offset='100%'></stop>
      </linearGradient>
      <linearGradient
        x1='50%'
        y1='0%'
        x2='50%'
        y2='100%'
        id='linearGradient-3-fr'
      >
        <stop stopColor='#1035BB' offset='0%'></stop>
        <stop stopColor='#042396' offset='100%'></stop>
      </linearGradient>
    </defs>
    <g
      id='Symbols'
      stroke='none'
      strokeWidth='1'
      fill='none'
      fillRule='evenodd'
    >
      <g id='FR'>
        <rect
          id='FlagBackground'
          fill='url(#linearGradient-1-fr)'
          x='0'
          y='0'
          width='21'
          height='15'
        ></rect>
        <rect
          id='Mask'
          fill='url(#linearGradient-2-fr)'
          x='10'
          y='0'
          width='11'
          height='15'
        ></rect>
        <rect
          id='Rectangle-2'
          fill='url(#linearGradient-3-fr)'
          x='0'
          y='0'
          width='7'
          height='15'
        ></rect>
        <rect
          id='Rectangle-2-Copy'
          fill='url(#linearGradient-1-fr)'
          x='7'
          y='0'
          width='7'
          height='15'
        ></rect>
      </g>
    </g>
  </svg>
)

export const LU = () => (
  <svg
    width='21px'
    height='15px'
    viewBox='0 0 21 15'
    version='1.1'
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>LU</title>
    <defs>
      <linearGradient
        x1='50%'
        y1='0%'
        x2='50%'
        y2='100%'
        id='linearGradient-1-lu'
      >
        <stop stopColor='#FFFFFF' offset='0%'></stop>
        <stop stopColor='#F0F0F0' offset='100%'></stop>
      </linearGradient>
      <linearGradient
        x1='50%'
        y1='0%'
        x2='50%'
        y2='100%'
        id='linearGradient-2-lu'
      >
        <stop stopColor='#F14455' offset='0%'></stop>
        <stop stopColor='#EB2D3F' offset='100%'></stop>
      </linearGradient>
      <linearGradient
        x1='50%'
        y1='0%'
        x2='50%'
        y2='100%'
        id='linearGradient-3-lu'
      >
        <stop stopColor='#29B4EE' offset='0%'></stop>
        <stop stopColor='#1AA3DC' offset='100%'></stop>
      </linearGradient>
    </defs>
    <g
      id='Symbols'
      stroke='none'
      strokeWidth='1'
      fill='none'
      fillRule='evenodd'
    >
      <g id='LU'>
        <rect
          id='FlagBackground'
          fill='url(#linearGradient-1-lu)'
          x='0'
          y='0'
          width='21'
          height='15'
        ></rect>
        <rect
          id='Rectangle-2'
          fill='url(#linearGradient-2-lu)'
          x='0'
          y='0'
          width='21'
          height='5'
        ></rect>
        <rect
          id='Rectangle-2'
          fill='url(#linearGradient-3-lu)'
          x='0'
          y='10'
          width='21'
          height='5'
        ></rect>
        <rect
          id='Rectangle-2'
          fill='url(#linearGradient-1-lu)'
          x='0'
          y='5'
          width='21'
          height='5'
        ></rect>
      </g>
    </g>
  </svg>
)

export const NL = () => (
  <svg
    width='21px'
    height='15px'
    viewBox='0 0 21 15'
    version='1.1'
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>NL</title>
    <defs>
      <linearGradient
        x1='50%'
        y1='0%'
        x2='50%'
        y2='100%'
        id='linearGradient-1-nl'
      >
        <stop stopColor='#FFFFFF' offset='0%'></stop>
        <stop stopColor='#F0F0F0' offset='100%'></stop>
      </linearGradient>
      <linearGradient
        x1='50%'
        y1='0%'
        x2='50%'
        y2='100%'
        id='linearGradient-2-nl'
      >
        <stop stopColor='#CA2B39' offset='0%'></stop>
        <stop stopColor='#AC1F2C' offset='100%'></stop>
      </linearGradient>
      <linearGradient
        x1='50%'
        y1='0%'
        x2='50%'
        y2='100%'
        id='linearGradient-3-nl'
      >
        <stop stopColor='#2C56A2' offset='0%'></stop>
        <stop stopColor='#244889' offset='100%'></stop>
      </linearGradient>
    </defs>
    <g
      id='Symbols'
      stroke='none'
      strokeWidth='1'
      fill='none'
      fillRule='evenodd'
    >
      <g id='NL'>
        <rect
          id='FlagBackground'
          fill='url(#linearGradient-1-nl)'
          x='0'
          y='0'
          width='21'
          height='15'
        ></rect>
        <rect
          id='Rectangle-2'
          fill='url(#linearGradient-2-nl)'
          x='0'
          y='0'
          width='21'
          height='5'
        ></rect>
        <rect
          id='Rectangle-2'
          fill='url(#linearGradient-3-nl)'
          x='0'
          y='10'
          width='21'
          height='5'
        ></rect>
        <rect
          id='Rectangle-2'
          fill='url(#linearGradient-1-nl)'
          x='0'
          y='5'
          width='21'
          height='5'
        ></rect>
      </g>
    </g>
  </svg>
)

export const DK = () => (
  <svg
    width='21px'
    height='15px'
    viewBox='0 0 21 15'
    version='1.1'
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>DK</title>
    <defs>
      <linearGradient
        x1='50%'
        y1='0%'
        x2='50%'
        y2='100%'
        id='linearGradient-1-dk'
      >
        <stop stopColor='#FFFFFF' offset='0%'></stop>
        <stop stopColor='#F0F0F0' offset='100%'></stop>
      </linearGradient>
      <linearGradient
        x1='50%'
        y1='0%'
        x2='50%'
        y2='100%'
        id='linearGradient-2-dk'
      >
        <stop stopColor='#EF264D' offset='0%'></stop>
        <stop stopColor='#E1143C' offset='100%'></stop>
      </linearGradient>
    </defs>
    <g
      id='Symbols'
      stroke='none'
      strokeWidth='1'
      fill='none'
      fillRule='evenodd'
    >
      <g id='DK'>
        <rect
          id='FlagBackground'
          fill='url(#linearGradient-1-dk)'
          x='0'
          y='0'
          width='21'
          height='15'
        ></rect>
        <rect
          id='Mask-Copy'
          fill='url(#linearGradient-2-dk)'
          x='0'
          y='0'
          width='21'
          height='15'
        ></rect>
        <polygon
          id='Rectangle-2'
          fill='url(#linearGradient-1-dk)'
          points='0 9 6 9 6 15 9 15 9 9 21 9 21 6 9 6 9 0 6 0 6 6 0 6'
        ></polygon>
      </g>
    </g>
  </svg>
)

export const AT = () => (
  <svg
    width='21px'
    height='15px'
    viewBox='0 0 21 15'
    version='1.1'
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>AT</title>
    <defs>
      <linearGradient
        x1='50%'
        y1='0%'
        x2='50%'
        y2='100%'
        id='linearGradient-1-at'
      >
        <stop stopColor='#FFFFFF' offset='0%'></stop>
        <stop stopColor='#F0F0F0' offset='100%'></stop>
      </linearGradient>
      <linearGradient
        x1='50%'
        y1='0%'
        x2='50%'
        y2='100%'
        id='linearGradient-2-at'
      >
        <stop stopColor='#F64253' offset='0%'></stop>
        <stop stopColor='#EA2D3F' offset='100%'></stop>
      </linearGradient>
    </defs>
    <g
      id='Symbols'
      stroke='none'
      strokeWidth='1'
      fill='none'
      fillRule='evenodd'
    >
      <g id='AT'>
        <rect
          id='FlagBackground'
          fill='url(#linearGradient-1-at)'
          x='0'
          y='0'
          width='21'
          height='15'
        ></rect>
        <rect
          id='Rectangle-2'
          fill='url(#linearGradient-2-at)'
          x='0'
          y='0'
          width='21'
          height='5'
        ></rect>
        <rect
          id='Rectangle-2'
          fill='url(#linearGradient-2-at)'
          x='0'
          y='10'
          width='21'
          height='5'
        ></rect>
        <rect
          id='Rectangle-2'
          fill='url(#linearGradient-1-at)'
          x='0'
          y='5'
          width='21'
          height='5'
        ></rect>
      </g>
    </g>
  </svg>
)

export const BE = () => (
  <svg
    width='21px'
    height='15px'
    viewBox='0 0 21 15'
    version='1.1'
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>BE</title>
    <defs>
      <linearGradient
        x1='50%'
        y1='0%'
        x2='50%'
        y2='100%'
        id='linearGradient-1-be'
      >
        <stop stopColor='#FFFFFF' offset='0%'></stop>
        <stop stopColor='#F0F0F0' offset='100%'></stop>
      </linearGradient>
      <linearGradient
        x1='50%'
        y1='0%'
        x2='50%'
        y2='100%'
        id='linearGradient-2-be'
      >
        <stop stopColor='#FF4453' offset='0%'></stop>
        <stop stopColor='#EE2A39' offset='100%'></stop>
      </linearGradient>
      <linearGradient
        x1='50%'
        y1='0%'
        x2='50%'
        y2='100%'
        id='linearGradient-3-be'
      >
        <stop stopColor='#262626' offset='0%'></stop>
        <stop stopColor='#0D0D0D' offset='100%'></stop>
      </linearGradient>
      <linearGradient
        x1='50%'
        y1='0%'
        x2='50%'
        y2='100%'
        id='linearGradient-4-be'
      >
        <stop stopColor='#FFCF3C' offset='0%'></stop>
        <stop stopColor='#FECB2F' offset='100%'></stop>
      </linearGradient>
    </defs>
    <g
      id='Symbols'
      stroke='none'
      strokeWidth='1'
      fill='none'
      fillRule='evenodd'
    >
      <g id='BE'>
        <rect
          id='FlagBackground'
          fill='url(#linearGradient-1-be)'
          x='0'
          y='0'
          width='21'
          height='15'
        ></rect>
        <rect
          id='Mask'
          fill='url(#linearGradient-2-be)'
          x='10'
          y='0'
          width='11'
          height='15'
        ></rect>
        <rect
          id='Rectangle-2'
          fill='url(#linearGradient-3-be)'
          x='0'
          y='0'
          width='7'
          height='15'
        ></rect>
        <rect
          id='Rectangle-2-Copy'
          fill='url(#linearGradient-4-be)'
          x='7'
          y='0'
          width='7'
          height='15'
        ></rect>
      </g>
    </g>
  </svg>
)
